import { cn } from "@/lib/utils";
import Title from "./Title";

interface FieldsetProps {
  className?: string;
  children: React.ReactNode;
  title?: React.ReactNode;
}

export default function Fieldset({
  className,
  children,
  title,
}: FieldsetProps) {
  return (
    <>
      {title && (
        <Title level={4} className="mb-2 mt-5">
          {title}
        </Title>
      )}
      <fieldset className={cn("flex flex-col gap-4 my-4", className)}>
        {children}
      </fieldset>
    </>
  );
}
